import React, { PureComponent } from 'react';

import { Pagination } from 'components/ClubComponents';
import { I18n } from 'components/translate';

import DataTableContext from './DataTableContext';

class DataTablePagination extends PureComponent {
  handleChange =
    (actions, data) =>
    ({ currentPage, pageSize }) => {
      if (pageSize !== data.perPage) {
        actions.onChangePerPage(pageSize);
      } else if (currentPage !== data.pagination.page) {
        actions.onChangePage(currentPage);
      }
    };

  renderPagination = ({ actions, data }) => (
    <Pagination
      id="data-table-pagination"
      label={<I18n label="pagination.registers_per_page" />}
      currentPage={data.pagination.page}
      maxPages={6}
      pageSize={data.perPage}
      onChange={this.handleChange(actions, data)}
      totalItems={data.pagination.totalElements}
    />
  );

  render() {
    return (
      <DataTableContext.Consumer>
        {this.renderPagination}
      </DataTableContext.Consumer>
    );
  }
}

export default DataTablePagination;
